<template>
  <svg class="role-icon" :viewBox="kind === 'driver' ? '0 0 64 64' : '0 0 24 24'" aria-hidden="true" focusable="false">
    <!-- Graduation cap — school / education, not an office block -->
    <path
      v-if="kind === 'school'"
      d="M12 3L1 9l11 6 9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"
    />
    <!-- Guardian with child in front — adult standing with the child -->
    <g v-else-if="kind === 'family'">
      <circle cx="8.2" cy="4.4" r="2.5" />
      <path d="M3.4 8.1c0-.7.6-1.3 1.4-1.3h7.2c.8 0 1.4.6 1.4 1.3V14H11.6v8.2H4.8V14H3.4V8.1z" />
      <circle cx="16.6" cy="7.1" r="2.05" />
      <path d="M12.7 10.3c0-.55.45-1 1-1h5.8c.55 0 1 .45 1 1V15H19v7.2h-4.4V15h-1.9v-4.7z" />
      <path d="M12.2 9.2c1.8.35 3.2 1.15 4.2 2.15v1.7c-1.15-1.05-2.55-1.7-4.2-2.05V9.2z" />
    </g>
    <!-- Steering wheel -->
    <g v-else fill-rule="evenodd">
      <path d="M32 6c14.36 0 26 11.64 26 26S46.36 58 32 58 6 46.36 6 32 17.64 6 32 6zm0 5.2C19.3 11.2 11.2 19.3 11.2 32S19.3 52.8 32 52.8 52.8 44.7 52.8 32 44.7 11.2 32 11.2z" />
      <path d="M32 24.4a7.6 7.6 0 110 15.2 7.6 7.6 0 010-15.2z" />
      <path d="M29.6 13.2h4.8v12.6h-4.8zM13.4 29.6H26v4.8H13.4zM38 29.6h12.6v4.8H38z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RoleIcon',
  props: {
    kind: { type: String, required: true },
  },
}
</script>

<style scoped>
.role-icon {
  width: 108px;
  height: 108px;
  display: block;
  fill: var(--gold);
}
</style>
